import { i18next } from '@frontend/i18n';

export const SCREENS = {
  CALL_DETAILS: 'CALL_DETAILS',
  CALL_QUALITY: 'CALL_QUALITY',
  CALL_QUALITY_DRILLDOWN: 'CALL_QUALITY_DRILLDOWN',
} as const;

export const metricInfo = {
  mosMin: {
    title: i18next.t('MOS (min.)', { ns: 'calls' }),
    description: [
      i18next.t(
        'This metric represents the lowest MOS detected on the call. Recommended MOS is greater than 3.5 out of 5.',
        { ns: 'calls' }
      ),
      i18next.t(
        'The Mean Opinion Score (MOS) indicates the overall quality of a VoIP call. It is a subjective measurement that aims to predict human perception of audio quality, but it correlates with objective metrics like packet loss, jitter, and latency. A score of 1 represents poor quality and 5 indicates excellent quality.',
        { ns: 'calls' }
      ),
    ],
  },
  mos: {
    title: i18next.t('MOS', { ns: 'calls' }),
    description: [
      i18next.t(
        'The Mean Opinion Score (MOS) indicates the overall quality of a VoIP call. It is a subjective measurement that aims to predict human perception of audio quality, but it correlates with objective metrics like packet loss, jitter, and latency. A score of 1 represents poor quality and 5 indicates excellent quality.',
        { ns: 'calls' }
      ),
    ],
  },
  mosAvg: {
    title: i18next.t('MOS (avg.)', { ns: 'calls' }),
    description: [
      i18next.t(
        'This metric represents the average MOS calculated from the values collected during the low-quality interval.',
        { ns: 'calls' }
      ),
      i18next.t(
        'The Mean Opinion Score (MOS) indicates the overall quality of a VoIP call. It is a subjective measurement that aims to predict human perception of audio quality, but it correlates with objective metrics like packet loss, jitter, and latency. A score of 1 represents poor quality and 5 indicates excellent quality.',
        { ns: 'calls' }
      ),
    ],
  },
  packetLossMax: {
    title: i18next.t('Packet Loss (max.)', { ns: 'calls' }),
    description: [
      i18next.t('This metric represents the maximum packet loss detected on the call.', { ns: 'calls' }),
      i18next.t(
        'Packet loss occurs when voice data packets traveling across a network fail to reach their destination. When packets are lost, it can result in gaps or distortion in the audio, leading to a degraded call quality.',
        { ns: 'calls' }
      ),
    ],
  },
  packetLossAvg: {
    title: i18next.t('Packet Loss (avg.)', { ns: 'calls' }),
    description: [
      i18next.t(
        'This metric represents the average packet loss calculated from the values collected during the low-quality interval.',
        { ns: 'calls' }
      ),
      i18next.t(
        'Packet loss occurs when voice data packets traveling across a network fail to reach their destination. When packets are lost, it can result in gaps or distortion in the audio, leading to a degraded call quality.',
        { ns: 'calls' }
      ),
    ],
  },
  jitterMax: {
    title: i18next.t('Jitter (max.)', { ns: 'calls' }),
    description: [
      i18next.t('This metric represents the maximum jitter detected on the call.', { ns: 'calls' }),
      i18next.t(
        'Jitter is the variation in the time it takes for voice data packets to reach their destination. Jitter occurs when these packets arrive at different times, causing variations in the arrival times of the audio segments. Jitter can result in uneven, choppy, or garbled audio.',
        { ns: 'calls' }
      ),
    ],
  },
  jitterAvg: {
    title: i18next.t('Jitter (avg.)', { ns: 'calls' }),
    description: [
      i18next.t(
        'This metric represents the average jitter calculated from the values collected during the low-quality interval.',
        { ns: 'calls' }
      ),
      i18next.t(
        'Jitter is the variation in the time it takes for voice data packets to reach their destination. Jitter occurs when these packets arrive at different times, causing variations in the arrival times of the audio segments. Jitter can result in uneven, choppy, or garbled audio.',
        { ns: 'calls' }
      ),
    ],
  },
} as const;

export const CALL_QUALITY = {
  GOOD: 'good',
  BAD: 'bad',
} as const;
